import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { Portfolio } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { createStyles } from './styles';

interface Props {
  portfolio: Portfolio;
  isMobileView: boolean;
}

const CartItemSelectBar = observer(({ portfolio, isMobileView }: Props): JSX.Element => {
  const {
    proposalCartStore: { cart, onRemoveFromCart },
  } = useRootStore();

  const convertedCart = toJS(cart);

  function onRemove(): void {
    void onRemoveFromCart(portfolio.id);
  }

  const isButtonChecked = !!convertedCart.cartItems.find((cartItem) => cartItem.portfolioId === portfolio.id);

  const classes = createStyles();
  return (
    <>
      {isMobileView ? (
        <div className={classes.mobileActionBlock}>
          {isButtonChecked && (
            <Button onClick={onRemove} type="outlined" color="custom" customColor={colors.red[500]} size="large">
              Remove
            </Button>
          )}
        </div>
      ) : (
        <div className={classes.actionBlock}>
          {isButtonChecked && (
            <Button color="primary" size="large" type="opaque">
              Plan Added
            </Button>
          )}
          {isButtonChecked && (
            <Button
              onClick={onRemove}
              type="text"
              color="custom"
              customColor={colors.red[500]}
              className={classes.undoBtn}
            >
              REMOVE
            </Button>
          )}
        </div>
      )}
    </>
  );
});

export default CartItemSelectBar;
